import React from 'react';
import styled from 'styled-components/native';
import TextGeneric from '../textGeneric';
import ProgressiveImage from '../progressiveImage';
import {HomeTabsProps} from '../../interfaces/components/homeTabs';

const Container = styled.TouchableOpacity<{hideImage?: boolean}>`
  width: 100%;
  background-color: ${({theme}) => theme.quickAccess.background};
  padding: 10% 5%;
  align-items: center;
  justify-content: center;
  border-color: ${({theme}) => theme.quickAccess.iconBackground};
  border-width: 2px;
`;
const ImageContainer = styled.View`
  width: 70%;
  aspect-ratio: 1;
  background-color: ${({theme}) => theme.quickAccess.iconBackground};
  border-radius: 1000px;
  overflow: hidden;
  padding: 15%;
  align-items: center;
  justify-content: center;
`;
const Image = styled(ProgressiveImage)`
  width: 100%;
  aspect-ratio: 1;
`;
const Title = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s6}px;
  color: ${({theme}) => theme.text.dark};
  padding-top: 10%;
`;

const QuickAccess = ({
  title,
  titleStyle,
  style,
  onPress,
  imageUri,
  defaultImage,
  hideImage,
}: HomeTabsProps): React.ReactElement => {
  return (
    <Container
      hideImage={hideImage}
      activeOpacity={0.7}
      disabled={!onPress}
      onPress={() => onPress?.()}
      style={[{borderRadius: 30}, style]}>
      <ImageContainer>
        <Image
          hideLoader
          resizeMode={'contain'}
          source={{uri: imageUri}}
          defaultImage={
            defaultImage ||
            require('../../assets/images/newsCardBackground.png')
          }
        />
      </ImageContainer>
      <Title bold numberOfLines={3} style={titleStyle}>
        {title || ''}
      </Title>
    </Container>
  );
};

export default QuickAccess;
